import {
  WizardBottomBar,
  WizardBottomBarSection,
  WizardBottomBarSpacer,
} from '@/components/Wizard'
import type { ReactNode } from 'react'

interface MeasureOneWizardBottomBarProps {
  children: ReactNode
}

export function MeasureOneWizardBottomBar({
  children,
}: MeasureOneWizardBottomBarProps) {
  return (
    <WizardBottomBar progress={0}>
      <WizardBottomBarSpacer />
      <WizardBottomBarSection>{children}</WizardBottomBarSection>
    </WizardBottomBar>
  )
}
